import { useEffect, useRef } from "react";
import { Box, Grid, Text } from "theme-ui";
import LegendPill from "./LegendPill";
import * as echarts from "echarts";
import PieChartSkeleton from "../../skeleton/PieChartSkeleton";
const ApprovedProjects = ({ data, loading, colorMode }: any) => {
    const chartRef = useRef(null);
    const bgDashboard = colorMode === 'light' ? "#ffffff" : "#252b36";
    useEffect(() => {
        if (!chartRef.current) return;
        const chart = echarts.init(chartRef.current);

        const chartData = [
            { value: data?.Residential || 0, name: "Residential", color: "rgba(140, 198, 62, 1)" },
            { value: data?.Commercial || 0, name: "Commercial", color: "rgba(32, 120, 207, 1)" },
            { value: data?.["Mix-use"] || 0, name: "Mix-use", color: "rgba(61, 73, 142, 1)" },
            { value: data?.Industrial || 0, name: "Industrial", color: "rgba(241, 161, 26, 1)" },
        ];

        const option = {
            tooltip: {
                trigger: "item",
                backgroundColor: "#fff",
                borderColor: "#ddd",
                borderWidth: 0.5,
                padding: 1,
                textStyle: { color: "#333", fontSize: 14 },
                formatter: (params: any) => `
      <div style="display:flex;align-items:center;gap:6px;padding:8px;border-radius:10px;">
        <span style="width:10px;height:10px;background:${params.color};border-radius:50%;display:inline-block;"></span>
        <strong style="font-size:10px;font-weight:500; color:rgba(69, 53, 33, 1);">${params.name}: ${params.percent}%</strong>
      </div>
    `,
            },
            series: [
                {
                    name: "Approved",
                    type: "pie",
                    radius: ["0%", "95%"],
                    avoidLabelOverlap: false,
                    label: {
                        show: true,
                        position: "inside",
                        formatter: "",
                        fontSize: "10px",
                        fontWeight: 500,
                        color: "#fff",
                        distanceToLabelLine: 4,
                        distance: 12,
                    },

                    itemStyle: {
                        borderColor: "#fff",
                        borderWidth: 2,
                        borderRadius: 0,
                        shadowBlur: 4,
                        shadowColor: "rgba(0,0,0,0.08)",
                    },
                    data: chartData.map((x) => ({
                        value: x.value,
                        name: x.name,
                        itemStyle: { color: x.color },
                    })),
                },
            ],
        };

        chart.setOption(option);

        // Responsive
        const handleResize = () => chart.resize();
        window.addEventListener("resize", handleResize);

        return () => {
            window.removeEventListener("resize", handleResize);
            chart.dispose();
        };
    }, [data]);
    if (loading || !data) {
        return <PieChartSkeleton />
    }
    return <Box>
        <Box
            sx={{
                bg: bgDashboard,
                p: 20,
                borderRadius: "24px",
                boxShadow: "0px 0px 40px 0px rgba(209, 173, 138, 0.12)",
                height: ["450px", "495px"]
            }}
        >
            <Text sx={{ fontSize: ["9px", "10px", "12px", "16px",], fontWeight: 600, mb: "16px", color: colorMode === 'light' ? '#453521' : '#f8f9fab5' }}>
                Approved Projects
            </Text>

            {/* Chart */}
            <div ref={chartRef} style={{ width: "100%", height: "260px", marginTop: "35px" }} />

            {/* Legend */}
            <Box sx={{ marginTop: "30px" }}>

                <Grid columns={[2]}>
                    <LegendPill label="Residential" value={data?.Residential} color={"rgba(140, 198, 62, 1)"} />
                    <LegendPill label="Commercial" value={data?.Commercial} color={"rgba(32, 120, 207, 1)"} />
                    <LegendPill label="Mix-use" value={data?.["Mix-use"]} color={"rgba(61, 73, 142, 1)"} />
                    <LegendPill label="Industrial" value={data?.Industrial} color={"rgba(241, 161, 26, 1)"} />
                </Grid>
            </Box>
        </Box>
    </Box>
};

export default ApprovedProjects